import { Component, OnInit, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { User } from "src/app/core/user/user";
import { UserService } from "src/app/core/user/user.service";

@Component({
  selector: "app-nav-list",
  templateUrl: "./nav-list.component.html",
  styleUrls: ["./nav-list.component.css"],
})
export class NavListComponent implements OnInit {
  isAdmin: boolean;
  pdfContrato: string =
    "http://ibolthost.com.br/pdf/biotech/CONTRATO%20PACIENTE%202021%20BASE28022021.pdf";
  pdfExame: string =
    "http://ibolthost.com.br/pdf/biotech/exames-sanguineos.pdf";
  pdfManual: string = "http://ibolthost.com.br/pdf/biotech/manual_tecnico.pdf";
  pdfPrecos: string = "http://ibolthost.com.br/pdf/biotech/tabela_precos.pdf";
  constructor(
    private userService: UserService,
    private router: Router,
    private pdf: MatDialog
  ) {
    // this.isAdmin = this.userService.isAdmin();
  }

  ngOnInit() {}

  createEmprea() {}

  logout() {
    this.userService.logout();
    // this.empresaService.resetEmpresa();
    // this.empresaService.setEmpresaNow(null);
    this.router.navigate(["/"]);
  }

  openTermo() {}

  openContrato() {
    window.open(this.pdfContrato);
  }

  openExames() {
    window.open(this.pdfExame);
  }

  openManual() {
    window.open(this.pdfManual);
  }

  openPrecos() {
    window.open(this.pdfPrecos);
  }
}
